/*
Libraries aready present that can use used
- jQuery
- slick
- swiper
- photoswipe

Notes:
1. the `floraqueen` It is a special object that has been created where all the information like locations, prices, special notes will be stored.
*/

let has_deluxe = $('[data-name="Deluxe"]').length;
let has_premium = $('[data-name="Premium"]').length;

if(has_premium){
    $('[data-name="Premium"]').click();
}else if(has_deluxe){
    $('[data-name="Deluxe"]').click();
}

window.floraqueen = window.floraqueen || {};

// Define SheetJSON URLs
const fixedPriceUrl = "https://sheetjson.com/spreadsheets/d/12-aI_r6LIb6dAwvoNUkMAJJ6f3sffxNQElkiOUnTu1I/edit?gid=1353294071#gid=1353294071";
const priceModifierUrl = "https://sheetjson.com/spreadsheets/d/12-aI_r6LIb6dAwvoNUkMAJJ6f3sffxNQElkiOUnTu1I/edit?gid=198474917#gid=198474917";
const countryCodesUrl = "https://sheetjson.com/spreadsheets/d/12-aI_r6LIb6dAwvoNUkMAJJ6f3sffxNQElkiOUnTu1I/edit?gid=1726063397#gid=1726063397";

// LocalStorage keys
const STORAGE_KEYS = {
  FULL_ADDRESS: 'floraqueen_fullDeliveryAddress',
  COUNTRY: 'floraqueen_deliveryCountry',
  COUNTRY_CODE: 'floraqueen_deliveryCountryCode'
};

// Default market settings
const DEFAULT_MARKET = 'ES'; // Spain as default
const DEFAULT_LANGUAGE = 'en'; // English as default language

// Get User Country
(async () => {
  const res = await fetch(
    window.Shopify.routes.root +
      'browsing_context_suggestions.json' +
      `?country[enabled]=true` +
      `&country[exclude]=${window.Shopify.country}` +
      '&language[enabled]=true' +
      `&language[exclude]=${window.Shopify.language}`
  );
  const data = await res.json();
  window.floraqueen.user_country = data.detected_values;
})();

// Function to fetch data from SheetJSON
async function fetchSheetData(url) {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error);
    return null;
  }
}

// Check if a country code is available in the localization array
function isCountryInLocalization(countryCode) {
  if (!countryCode) return false;

  // Ensure localization exists
  if (!window.floraqueen.localization || !Array.isArray(window.floraqueen.localization)) {
    console.log("Localization array not available");
    return false;
  }

  // Check if country code is in the array (case insensitive)
  const found = window.floraqueen.localization.some(code =>
    code.toLowerCase() === countryCode.toLowerCase()
  );

  console.log(`Country check: ${countryCode} in localization: ${found}`);
  return found;
}

// Change market on Shopify and update data-price values on the current page
async function changeMarket(countryCode, languageCode = DEFAULT_LANGUAGE) {
  console.log(`Changing market to: ${countryCode}, language: ${languageCode}`);

  try {
    const formData = new URLSearchParams();
    formData.append('form_type', 'localization');
    formData.append('utf8', '✓');
    formData.append('_method', 'put');
    formData.append('return_to', location.pathname);
    formData.append('country_code', countryCode);
    formData.append('locale_code', languageCode);

    const res = await fetch('/localization', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'text/html'
      },
      body: formData.toString()
    });
    const htmlData = await res.text();

    // Parse the HTML response
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlData, 'text/html');

    // Get all elements with data-price attribute from the response
    const newPriceElements = Array.from(doc.querySelectorAll('[data-price-container]')).filter(el => !el.closest('.product-recommendations'));
    // const newComparePriceElements = Array.from(doc.querySelectorAll('[data-price]')).filter(el =>
    //                                       el.parentElement.hasAttribute('data-compare') &&
    //                                       !el.closest('.product-recommendations')
    //                                     );
    // console.log("New price values from response:");
    // console.log(newComparePriceElements);
    // newPriceElements.forEach((element, i) => {
    //   console.log(`[${i}] New price: ${element.getAttribute('data-price-container')}, Text: ${element.textContent.trim()}`);
    // });

    // Get all elements with data-price attribute on the current page
    const currentPriceElements = Array.from(document.querySelectorAll('[data-price-container]')).filter(el => !el.closest('.product-recommendations'));
    // const currentComparePriceElements = Array.from(document.querySelectorAll('[data-price]')).filter(el =>
    //                                       el.parentElement.hasAttribute('data-compare') &&
    //                                       !el.closest('.product-recommendations')
    //                                     );

    // console.log("Current price values on page:");
    // console.log(currentComparePriceElements);
    // currentPriceElements.forEach((element, i) => {
    //   console.log(`[${i}] Current price: ${element.getAttribute('data-price-container')}, Text: ${element.textContent.trim()}`);
    // });
    // console.log(newPriceElements)
    // console.log(currentPriceElements)
    // console.log(newComparePriceElements.length+'--'+currentComparePriceElements.length)

    const newPriceElements_1 = Array.from(doc.querySelectorAll('[data-price]')).filter(el => !el.closest('.product-recommendations'));
    console.log("New price values from response:");
    newPriceElements_1.forEach((element, i) => {
      console.log(`[${i}] New price: ${element.getAttribute('data-price')}, Text: ${element.textContent.trim()}`);
    });

    // Get all elements with data-price attribute on the current page
    const currentPriceElements_1 = Array.from(document.querySelectorAll('[data-price]')).filter(el => !el.closest('.product-recommendations'));
    console.log("Current price values on page:");
    currentPriceElements_1.forEach((element, i) => {
      console.log(`[${i}] Current price: ${element.getAttribute('data-price')}, Text: ${element.textContent.trim()}`);
    });

    const delivery_date = document.querySelector(".sdd-outer-cont");
    // const atc_container = document.querySelector("#atc-form-container");
    if(delivery_date)
      delivery_date.style.display = "block";
    // if(atc_container)
    //   atc_container.style.display = "block";

    // Since the structure is the same, we can update directly by index
    if (newPriceElements.length === currentPriceElements.length) {
      console.log("Updating prices...");

      let multplierData = '';
      if (localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE) !== floraqueen.user_country.country.handle) {
          multplierData = floraqueen.priceModifier.find(
              item => item["Country code"] === floraqueen.user_country.country.handle
          );
      }
      // console.log(multplierData)
      currentPriceElements.forEach((element, index) => {
        // Get existing values before update
        // const oldPrice = element.getAttribute('data-price-container');
        // const oldText = element.textContent.trim();

        // Update the data-price attribute
        const newPrice = newPriceElements[index];
        // let newPricehtml = newPrice.querySelectorAll('.prod-price').textContent;
        if(multplierData != '' && multplierData != undefined){
          newPrice.querySelectorAll('.prod-price').forEach((element, ind) => {
              let modifiedPrice;
              let newPricehtml = element.textContent.slice(1);
              newPricehtml = newPricehtml.replace(',', '.');
              newPricehtml = parseFloat(newPricehtml);
              // console.log(`[${index}] Updated: ${oldPrice} → ${newPrice}, Text: ${oldText} → ${element.textContent.trim()}`)
              if (multplierData["Price modifier option"] === "%") {
                  modifiedPrice = newPricehtml * multplierData["% modifier"];
              } else {
                  modifiedPrice = newPricehtml + multplierData["% modifier"];
              }
              modifiedPrice = modifiedPrice.toFixed(2).replace('.', ',')
              element.textContent = element.textContent[0]+modifiedPrice;
              element.setAttribute('data-price', modifiedPrice)
              console.log(index+'. Modified Price: '+modifiedPrice)
          })
        }

        // Also update the displayed text content
        element.replaceWith(newPrice);

        // Log the change
        // console.log(`[${index}] Updated: ${oldPrice} → ${newPrice}, Text: ${oldText} → ${element.textContent.trim()}`);
      });



      if(location.href.includes('/products/')){
        const sectionEl = doc.querySelector('.product-recommendations');
        const reco_request = await fetch(sectionEl.dataset.url)
        const reco_request_result = await reco_request.text()
        const reco_html = parser.parseFromString(reco_request_result, 'text/html');

        // Get Reco Prices
        const newRecoPriceElements = Array.from(reco_html.querySelectorAll('[data-price-container]')).filter(el => el.closest('.product-recommendations'));
        const currentRecoPriceElements = Array.from(document.querySelectorAll('[data-price-container]')).filter(el => el.closest('.product-recommendations'));

        const newRecoPriceElements_1 = Array.from(reco_html.querySelectorAll('[data-price]')).filter(el => el.closest('.product-recommendations'));
        console.log("New price values from response:");
        newRecoPriceElements_1.forEach((element, i) => {
          console.log(`[${i}] New price: ${element.getAttribute('data-price')}, Text: ${element.textContent.trim()}`);
        });

        // Get all elements with data-price attribute on the current page
        const currentRecoPriceElements_1 = Array.from(document.querySelectorAll('[data-price]')).filter(el => el.closest('.product-recommendations'));
        console.log("Current price values on page:");
        currentRecoPriceElements_1.forEach((element, i) => {
          console.log(`[${i}] Current price: ${element.getAttribute('data-price')}, Text: ${element.textContent.trim()}`);
        });

        currentRecoPriceElements.forEach((element, index) => {
        const newPrice = newRecoPriceElements[index];
        if(multplierData != '' && multplierData != undefined){
          newPrice.querySelectorAll('.prod-price').forEach((element, ind) => {
              let modifiedPrice;
              let newPricehtml = element.textContent.slice(1);
              newPricehtml = newPricehtml.replace(',', '.');
              newPricehtml = parseFloat(newPricehtml);
              if (multplierData["Price modifier option"] === "%") {
                  modifiedPrice = newPricehtml * multplierData["% modifier"];
              } else {
                  modifiedPrice = newPricehtml + multplierData["% modifier"];
              }
              modifiedPrice = modifiedPrice.toFixed(2).replace('.', ',')
              element.textContent = element.textContent[0]+modifiedPrice;
              element.setAttribute('data-price', modifiedPrice)
              console.log(index+'. Modified Price: '+modifiedPrice)
          })
        }
        element.replaceWith(newPrice);
      });
    }

      console.log(`Updated ${currentPriceElements.length} price elements on the page`);
      return {
        success: true,
        pricesUpdated: currentPriceElements.length
      };
    } else {
      console.warn(`Mismatch in price elements count: response has ${newPriceElements.length}, current page has ${currentPriceElements.length}`);
      return {
        success: true,
        pricesUpdated: 0
      };
    }
  } catch (error) {
    console.error('Market change failed:', error);
    return {
      success: false,
      pricesUpdated: 0
    };
  }
}

// Handle market change based on country code
function handleMarketChange(countryCode) {
  if (!countryCode) {
    console.error("Cannot handle market change: Country code is missing");
    return;
  }

  console.log(`Handling market change for: ${countryCode}`);

  // Check if the country is available in localization
  if (isCountryInLocalization(countryCode)) {
    // Country is available, use it
    console.log(`${countryCode} is available in localization, using it`);
    changeMarket(countryCode);
  } else {
    // Country not available, use default
    console.log(`${countryCode} is NOT available in localization, using default: ${DEFAULT_MARKET}`);
    changeMarket(DEFAULT_MARKET);
  }
}

// Load saved address data from localStorage
function loadSavedAddressData() {
  const fullAddress = localStorage.getItem(STORAGE_KEYS.FULL_ADDRESS);
  const country = localStorage.getItem(STORAGE_KEYS.COUNTRY);
  const countryCode = localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE);

  if (fullAddress) window.floraqueen.fullDeliveryAddress = fullAddress;
  if (country) window.floraqueen.deliveryCountry = country;
  if (countryCode) window.floraqueen.deliveryCountryCode = countryCode;

  if (country || countryCode) {
    console.log("Loaded saved delivery details:", {
      fullAddress: window.floraqueen.fullDeliveryAddress || "Not saved",
      country: window.floraqueen.deliveryCountry || "Not saved",
      countryCode: window.floraqueen.deliveryCountryCode || "Not saved"
    });

    // If we have an address and an input field exists, update its value
    const addressInput = document.getElementById("productPageAddressInput");
    if (addressInput && fullAddress) {
      addressInput.value = fullAddress;
    }
  }
}

// Fetch data and store in floraqueen object
Promise.all([
  fetchSheetData(fixedPriceUrl),
  fetchSheetData(priceModifierUrl),
  fetchSheetData(countryCodesUrl)
]).then(([fixedPriceData, priceModifierData, countryCodesData]) => {
  window.floraqueen.fixedPrice = fixedPriceData;
  window.floraqueen.priceModifier = priceModifierData;
  window.floraqueen.countryCodes = countryCodesData;
  console.log('Data loaded successfully');

  // Load saved address data after country codes are loaded
  loadSavedAddressData();
  if(floraqueen.deliveryCountryCode != undefined && floraqueen.deliveryCountryCode != ''){
      handleMarketChange(floraqueen.deliveryCountryCode)
  }
}).catch(error => {
  console.error('Error loading data:', error);

  // Even if there's an error with the data, still try to load saved address
  loadSavedAddressData();
});

// selecting the Select delivery date
document.querySelectorAll('.sdd-item').forEach(item => {
  item.addEventListener('click', function(event) {
    const addon_wrapper = document.querySelector(".cpm-outer-cont");
    const atc_container = document.querySelector("#atc-form-container");
    if(atc_container)
      atc_container.style.display = "block";
    if(addon_wrapper)
      addon_wrapper.style.display = "block";
    document.querySelectorAll('.sdd-item').forEach(elem => {
        elem.classList.remove('sdd-active')
    })
    item.classList.add('sdd-active')
  });
});

// selecting the Choose the perfect match for your bouquet
$('.cpm-outer-cont:not(.section-addon-page) .cpm-item').each(function() {
    $(this).find('.cpm-right').on('click', () => {
        $(this).toggleClass('cpm-active');
    });
});

$(document).on('click', '.section-addon-page .cpm-right', function (e) {
  const $button = $(this);
  const $wrapper = $(this).closest('.cpm-item');
  const variantId = parseInt($wrapper.data('varid'), 10); // variant ID must be stored in data-varid

  if (isNaN(variantId)) {
    console.error('Invalid variant ID');
    return;
  }

  // If button has 'active' class → Remove product from cart
  if ($wrapper.hasClass('cpm-active')) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const item = cart.items.find(i => i.variant_id === variantId);
        if (!item) {
          console.warn('Product not found in cart');
          $wrapper.addClass('cpm-active')
          return;
        }

        // Remove item using its line number (1-based index in Shopify)
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        });
      })
      .then(res => res?.json?.())
      .then(data => {
        console.log('Product removed from cart:', data);
        $wrapper.removeClass('cpm-active');
      })
      .catch(err => {
        console.error('Error removing product from cart:', err);
      });
  } else {
    // Add item to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to add product');
        return res.json();
      })
      .then(data => {
        console.log('Product added to cart:', data);
        $wrapper.addClass('cpm-active');
      })
      .catch(err => {
        console.error('Error adding product to cart:', err);
      });
  }
})

$(document).on('click', 'button#delete-location', function (e) {
    $('#productPageAddressInput').val('');
    localStorage.removeItem(STORAGE_KEYS.FULL_ADDRESS);
    localStorage.removeItem(STORAGE_KEYS.COUNTRY);
    localStorage.removeItem(STORAGE_KEYS.COUNTRY_CODE);
})

$(document).on('click', '[data-add-to-cart]', function (e) {
  e.preventDefault();
  const $button = $(this);
  const $form = $button.closest('form');

  // Step 2: Fetch current cart first
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const itemCount = cart.item_count;

      // If needed, you could display a popup here using cart data
      if (itemCount) {
        console.log(cart.items[cart.items.length - 1])
        const myPopup = new Popup({
            id: "my-popup",
            title: '',
            hideCallback: () => {
                fetch('/cart/clear.js')
                .then(res => res.json())
                .then(cart => {
                  // console.log(cart)
                  location.reload()
                })
            },
            content: `<div class="relative bg-white max-w-xl md:max-w-3xl w-80 md:w-full z-popover rounded shadow-lg overflow-hidden"><div class="flex flex-col md:flex-row"><div class="w-full md:w-1/2 p-4"><img alt="Product image"  class="w-full h-auto object-contain max-h-60 md:max-h-none" src="${cart.items[cart.items.length - 1].image}"><div class="mt-2 prd-details-pop"><h3 class="">${cart.items[cart.items.length - 1].title}</h3><p class="mt-2">€${(cart.items[cart.items.length - 1].final_line_price / 100).toFixed(2)}</p></div><!----></div><div class="w-full md:w-1/2 p-4 md:pl-0 flex flex-col"><div class="pop-right flex flex-col justify-center h-full bg-red-50 p-3"><div><h2 class="text-xl md:text-4xl text-gray-900 pb-6">You've left this gift in your cart!</h2><p class="text-sm md:text-base text-gray-600 py-4 md:py-6">Join thousands of people who have gifted smiles with FloraQueen.</p></div><div class="space-y-4"><a href="/checkout" class="w-full btn btn--primary">Checkout now</a></div><div class="flex pt-4 items-center"><img width="70" alt="Best quality badge" loading="lazy" src="https://cdn.shopify.com/s/files/1/0895/6408/6600/files/best-quality-badge-icon.svg?v=1747826208"><div class="flex gap-1 ml-5" title=""><div><svg class="m-auto h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_887_2615)"><path d="M3.612 15.443C3.226 15.641 2.788 15.294 2.866 14.851L3.696 10.121L0.172996 6.76501C-0.156004 6.45101 0.0149962 5.87701 0.455996 5.81501L5.354 5.11901L7.538 0.792012C7.735 0.402012 8.268 0.402012 8.465 0.792012L10.649 5.11901L15.547 5.81501C15.988 5.87701 16.159 6.45101 15.829 6.76501L12.307 10.121L13.137 14.851C13.215 15.294 12.777 15.641 12.391 15.443L8 13.187L3.611 15.443H3.612Z" fill="#DD682E"></path></g><defs><clipPath id="clip0_887_2615"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><div><svg class="m-auto h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_887_2615)"><path d="M3.612 15.443C3.226 15.641 2.788 15.294 2.866 14.851L3.696 10.121L0.172996 6.76501C-0.156004 6.45101 0.0149962 5.87701 0.455996 5.81501L5.354 5.11901L7.538 0.792012C7.735 0.402012 8.268 0.402012 8.465 0.792012L10.649 5.11901L15.547 5.81501C15.988 5.87701 16.159 6.45101 15.829 6.76501L12.307 10.121L13.137 14.851C13.215 15.294 12.777 15.641 12.391 15.443L8 13.187L3.611 15.443H3.612Z" fill="#DD682E"></path></g><defs><clipPath id="clip0_887_2615"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><div><svg class="m-auto h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_887_2615)"><path d="M3.612 15.443C3.226 15.641 2.788 15.294 2.866 14.851L3.696 10.121L0.172996 6.76501C-0.156004 6.45101 0.0149962 5.87701 0.455996 5.81501L5.354 5.11901L7.538 0.792012C7.735 0.402012 8.268 0.402012 8.465 0.792012L10.649 5.11901L15.547 5.81501C15.988 5.87701 16.159 6.45101 15.829 6.76501L12.307 10.121L13.137 14.851C13.215 15.294 12.777 15.641 12.391 15.443L8 13.187L3.611 15.443H3.612Z" fill="#DD682E"></path></g><defs><clipPath id="clip0_887_2615"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><div><svg class="m-auto h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_887_2615)"><path d="M3.612 15.443C3.226 15.641 2.788 15.294 2.866 14.851L3.696 10.121L0.172996 6.76501C-0.156004 6.45101 0.0149962 5.87701 0.455996 5.81501L5.354 5.11901L7.538 0.792012C7.735 0.402012 8.268 0.402012 8.465 0.792012L10.649 5.11901L15.547 5.81501C15.988 5.87701 16.159 6.45101 15.829 6.76501L12.307 10.121L13.137 14.851C13.215 15.294 12.777 15.641 12.391 15.443L8 13.187L3.611 15.443H3.612Z" fill="#DD682E"></path></g><defs><clipPath id="clip0_887_2615"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><div><svg class="m-auto h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_887_2615)"><path d="M3.612 15.443C3.226 15.641 2.788 15.294 2.866 14.851L3.696 10.121L0.172996 6.76501C-0.156004 6.45101 0.0149962 5.87701 0.455996 5.81501L5.354 5.11901L7.538 0.792012C7.735 0.402012 8.268 0.402012 8.465 0.792012L10.649 5.11901L15.547 5.81501C15.988 5.87701 16.159 6.45101 15.829 6.76501L12.307 10.121L13.137 14.851C13.215 15.294 12.777 15.641 12.391 15.443L8 13.187L3.611 15.443H3.612Z" fill="#DD682E"></path></g><defs><clipPath id="clip0_887_2615"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><!----></div></div></div></div></div></div>`,
        });
        myPopup.show();
        return;
      }else{

          // Step 1: Ensure a delivery date is selected
        if ($(document).find('.sdd-item.sdd-active').length === 0) {
          $('.sdd-title').css('color', '#c64e14');
          setTimeout(function () {
            $('.sdd-title').css('color', '');
          }, 1500);
          return false;
        }

        // Extract the main variant ID from the form
        const mainVariantId = parseInt($form.find('[name="id"] option:selected').val(), 10);
        const mainVariantName = $form.find('[name="id"] option:selected')[0].label;
        if (isNaN(mainVariantId)) {
          console.error('Invalid variant ID');
          return;
        }

        // Initialize the items array with the main product
        let address = $('#productPageAddressInput').val();
        let del_date = $(document).find('.sdd-item.sdd-active');
        if($(document).find('.del-info-personalize').length){
          del_date = $(document).find('.del-info-personalize').attr('data-value');
        }else{
          if(del_date.hasClass('sdd-item-3')){
            del_date = del_date.find('#del-date').val();
          }else{
            del_date = del_date.data('value');
          }
        }
        // console.log(del_date)
        const items = [{
          id: mainVariantId,
          quantity: 1,
          properties: {
            'Delivery Date': del_date,
          }
        }];

        // Loop through additional selected items
        $('.cpm-item.cpm-active').each(function () {
          const variantId = parseInt($(this).data('varid'), 10);
          if (!isNaN(variantId)) {
            items.push({ id: variantId, quantity: 1 });
          }
        });

        let i_l_y = $('.cpm-item.ily-add:not(.cpm-active)').data('varid');
        if (typeof i_l_y !== 'undefined' && i_l_y !== null) {
          i_l_y = parseInt(i_l_y, 10);
          if (!isNaN(i_l_y)) {
            items.push({ id: i_l_y, quantity: 1 });
          }
        }

        // Log the payload for debugging
        console.log('Adding to cart:', JSON.stringify({ items }));

        let multplierData = '';
        if (localStorage.getItem(STORAGE_KEYS.COUNTRY_CODE) !== floraqueen.user_country.country.handle) {
            multplierData = floraqueen.priceModifier.find(
                item => item["Country code"] === floraqueen.user_country.country.handle
            );
        }

        // Step 4: Add to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
          }
          return response.json();
        })
        .then(data => {
          console.log('Products added to cart:', data);
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
              attributes: {
                'Delivery Address': address,
                'Delivery Date': del_date,
                'Country Code': multplierData["Country code"],
                'Multiplier Option': multplierData["Price modifier option"],
                'Multiplier Value': multplierData["% modifier"]
              }
            },
            dataType: 'json',
            success: function(cart) {
              console.log('Cart attributes updated:', cart.attributes);
            }
          });
          const redirectUrl = $button.data('addon');
          if(mainVariantName.includes('Deluxe') == true){
            window.location.href = '/checkout';
          }else{
            if (redirectUrl) {
              window.location.href = redirectUrl;
            }
          }
        })
        .catch(error => {
          console.error('Error adding items to cart:', error);
          if (error.message.includes('is already sold out')){
            $('.pdp-error-modal').addClass('active');
            $('.pdp-error-modal').find('span.pdp-error-highlight').text(floraqueen.user_country.country_name);
          } else {
            alert('The product is not available in the selected country of destination.');
          }
        });
      }
    })
    .then(response => {
      if (!response) return; // avoid error if early return
      if (!response.ok) {
        return response.json().then(err => Promise.reject(err));
      }
      return response.json();
    })
    .catch(error => {
      console.error('Error adding items to cart:', error);
      // alert('There was a problem adding products to your cart. Please try again.');
    });
});


// CART CLEAR IF A PRODUCT IN CART
$(window).on('load', function(){
  // if(window.location.href.includes('view=add-on')){
  //     $('.cpm-item[data-varid="50434757427528"]:not(.cpm-active) .cpm-right').click();
  // }
  // alert()
  if (!window.location.href.includes('view=add-on') && !window.location.href.includes('/account/')) {
     fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const itemCount = cart.item_count;
        if (itemCount) {
          console.log(cart.items[cart.items.length - 1])
          const myPopup = new Popup({
              id: "my-popup",
              title: '',
              hideCallback: () => {
                  fetch('/cart/clear.js')
                  .then(res => res.json())
                  .then(cart => {
                    // console.log(cart)
                    location.reload()
                  })
              },
              content: `<div class="relative bg-white max-w-xl md:max-w-3xl w-80 md:w-full z-popover rounded shadow-lg overflow-hidden"><div class="flex flex-col md:flex-row"><div class="w-full md:w-1/2 p-4"><img alt="Product image"  class="w-full h-auto object-contain max-h-60 md:max-h-none" src="${cart.items[cart.items.length - 1].image}"><div class="mt-2 prd-details-pop"><h3 class="">${cart.items[cart.items.length - 1].title}</h3><p class="mt-2">€${(cart.items[cart.items.length - 1].final_line_price / 100).toFixed(2)}</p></div><!----></div><div class="w-full md:w-1/2 p-4 md:pl-0 flex flex-col"><div class="pop-right flex flex-col justify-center h-full bg-red-50 p-3"><div><h2 class="text-xl md:text-4xl text-gray-900 pb-6">You've left this gift in your cart!</h2><p class="text-sm md:text-base text-gray-600 py-4 md:py-6">Join thousands of people who have gifted smiles with FloraQueen.</p></div><div class="space-y-4"><a href="/checkout" class="w-full btn btn--primary">Checkout now</a></div><div class="flex pt-4 items-center"><img width="70" alt="Best quality badge" loading="lazy" src="https://cdn.shopify.com/s/files/1/0895/6408/6600/files/best-quality-badge-icon.svg?v=1747826208"><div class="flex gap-1 ml-5" title=""><div><svg class="m-auto h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_887_2615)"><path d="M3.612 15.443C3.226 15.641 2.788 15.294 2.866 14.851L3.696 10.121L0.172996 6.76501C-0.156004 6.45101 0.0149962 5.87701 0.455996 5.81501L5.354 5.11901L7.538 0.792012C7.735 0.402012 8.268 0.402012 8.465 0.792012L10.649 5.11901L15.547 5.81501C15.988 5.87701 16.159 6.45101 15.829 6.76501L12.307 10.121L13.137 14.851C13.215 15.294 12.777 15.641 12.391 15.443L8 13.187L3.611 15.443H3.612Z" fill="#DD682E"></path></g><defs><clipPath id="clip0_887_2615"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><div><svg class="m-auto h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_887_2615)"><path d="M3.612 15.443C3.226 15.641 2.788 15.294 2.866 14.851L3.696 10.121L0.172996 6.76501C-0.156004 6.45101 0.0149962 5.87701 0.455996 5.81501L5.354 5.11901L7.538 0.792012C7.735 0.402012 8.268 0.402012 8.465 0.792012L10.649 5.11901L15.547 5.81501C15.988 5.87701 16.159 6.45101 15.829 6.76501L12.307 10.121L13.137 14.851C13.215 15.294 12.777 15.641 12.391 15.443L8 13.187L3.611 15.443H3.612Z" fill="#DD682E"></path></g><defs><clipPath id="clip0_887_2615"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><div><svg class="m-auto h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_887_2615)"><path d="M3.612 15.443C3.226 15.641 2.788 15.294 2.866 14.851L3.696 10.121L0.172996 6.76501C-0.156004 6.45101 0.0149962 5.87701 0.455996 5.81501L5.354 5.11901L7.538 0.792012C7.735 0.402012 8.268 0.402012 8.465 0.792012L10.649 5.11901L15.547 5.81501C15.988 5.87701 16.159 6.45101 15.829 6.76501L12.307 10.121L13.137 14.851C13.215 15.294 12.777 15.641 12.391 15.443L8 13.187L3.611 15.443H3.612Z" fill="#DD682E"></path></g><defs><clipPath id="clip0_887_2615"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><div><svg class="m-auto h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_887_2615)"><path d="M3.612 15.443C3.226 15.641 2.788 15.294 2.866 14.851L3.696 10.121L0.172996 6.76501C-0.156004 6.45101 0.0149962 5.87701 0.455996 5.81501L5.354 5.11901L7.538 0.792012C7.735 0.402012 8.268 0.402012 8.465 0.792012L10.649 5.11901L15.547 5.81501C15.988 5.87701 16.159 6.45101 15.829 6.76501L12.307 10.121L13.137 14.851C13.215 15.294 12.777 15.641 12.391 15.443L8 13.187L3.611 15.443H3.612Z" fill="#DD682E"></path></g><defs><clipPath id="clip0_887_2615"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><div><svg class="m-auto h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_887_2615)"><path d="M3.612 15.443C3.226 15.641 2.788 15.294 2.866 14.851L3.696 10.121L0.172996 6.76501C-0.156004 6.45101 0.0149962 5.87701 0.455996 5.81501L5.354 5.11901L7.538 0.792012C7.735 0.402012 8.268 0.402012 8.465 0.792012L10.649 5.11901L15.547 5.81501C15.988 5.87701 16.159 6.45101 15.829 6.76501L12.307 10.121L13.137 14.851C13.215 15.294 12.777 15.641 12.391 15.443L8 13.187L3.611 15.443H3.612Z" fill="#DD682E"></path></g><defs><clipPath id="clip0_887_2615"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg></div><!----></div></div></div></div></div></div>`,
          });
          myPopup.show();
          return;
        }
      })
      .then(response => {
        if (!response) return;
        if (!response.ok) {
          return response.json().then(err => Promise.reject(err));
        }
        return response.json();
      })
      .catch(error => {
        console.error('Error adding items to cart:', error);
        // alert('There was a problem adding products to your cart. Please try again.');
      });
    }

    if(window.location.href.includes('-addon') && !window.location.href.includes('view=add-on')){
      location.href = '/';
    }
})

document.addEventListener("DOMContentLoaded", function() {
  // Log available markets from localization
  console.log("Available markets:", window.floraqueen.localization);

  // Get the input element
  const addressInput = document.getElementById("productPageAddressInput");

  if (!addressInput) {
    console.log("Address input not found on page");
    return;
  }

  // Create a container for displaying suggestions
  const suggestionsContainer = document.createElement("div");
  suggestionsContainer.className = "address-suggestions";
  suggestionsContainer.style.display = "none";
  suggestionsContainer.style.position = "absolute";
  suggestionsContainer.style.width = "100%";
  suggestionsContainer.style.backgroundColor = "white";
  suggestionsContainer.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
  suggestionsContainer.style.zIndex = "1000";
  suggestionsContainer.style.borderRadius = "4px";
  suggestionsContainer.style.marginTop = "4px";

  // Insert suggestions container after the input container
  addressInput.parentNode.parentNode.insertBefore(suggestionsContainer, addressInput.parentNode.nextSibling);

  // Generate a session token (UUID v4-like)
  let sessionToken = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

  // Debounce function to prevent too many API calls
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // Function to extract country from address
  function extractCountryFromAddress(address) {
    if (!address) return null;

    // Split the address by commas and get the last part which is likely the country
    const parts = address.split(',');
    if (parts.length > 0) {
      // Get the last part and trim whitespace
      const country = parts[parts.length - 1].trim();
      return country;
    }

    return null;
  }

  // Function to get ISO country code from country name
  function getCountryCode(countryName) {
    if (!window.floraqueen.countryCodes || !countryName) return null;

    // First try exact match
    const exactMatch = window.floraqueen.countryCodes.find(
      item => item["Country Name"].toLowerCase() === countryName.toLowerCase()
    );

    if (exactMatch) return exactMatch["Country Code"];
    console.log("Country Name "+countryName)
    // Try to find a country that includes the countryName (for partial matches)
    const partialMatch = window.floraqueen.countryCodes.find(
      item => item["Country Name"].toLowerCase().includes(countryName.toLowerCase()) ||
             countryName.toLowerCase().includes(item["Country Name"].toLowerCase())
    );

    if (partialMatch) return partialMatch["Country Code"];

    return null;
  }

  // Function to save delivery address data to localStorage
  function saveDeliveryAddressData(fullAddress, country, countryCode) {
    if (fullAddress) localStorage.setItem(STORAGE_KEYS.FULL_ADDRESS, fullAddress);
    if (country) localStorage.setItem(STORAGE_KEYS.COUNTRY, country);
    if (countryCode) localStorage.setItem(STORAGE_KEYS.COUNTRY_CODE, countryCode);
  }

  // Function to fetch address suggestions
  async function fetchAddressSuggestions(input) {
    if (input.length < 3) {
      suggestionsContainer.style.display = "none";
      return;
    }

    try {
      const response = await fetch("https://address.deite.org/api/places-autocomplete", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          input,
          language: "en",
          sessionToken,
        }),
      });

      const data = await response.json();

      // Clear previous suggestions
      suggestionsContainer.innerHTML = "";

      // Display the suggestions
      if (data.suggestions && data.suggestions.length > 0) {
        suggestionsContainer.style.display = "block";

        data.suggestions.forEach((suggestion) => {
          const text = suggestion.placePrediction?.text?.text || "Unknown";

          const suggestionItem = document.createElement("div");
          suggestionItem.className = "suggestion-item";
          suggestionItem.textContent = text;
          suggestionItem.style.padding = "10px 15px";
          suggestionItem.style.cursor = "pointer";
          suggestionItem.style.borderBottom = "1px solid #f0f0f0";

          suggestionItem.addEventListener("mouseenter", function() {
            this.style.backgroundColor = "#f9f9f9";
          });

          suggestionItem.addEventListener("mouseleave", function() {
            this.style.backgroundColor = "transparent";
          });

          suggestionItem.addEventListener("click", function() {
            addressInput.value = text;
            suggestionsContainer.style.display = "none";

            // Store the full address
            window.floraqueen.fullDeliveryAddress = text;

            // Extract country from the selected address
            const country = extractCountryFromAddress(text);
            if (country) {
              // Store the country name
              window.floraqueen.deliveryCountry = country;

              // Get and store the ISO country code
              const countryCode = getCountryCode(country);
              if (countryCode) {
                // Check if country has changed
                const previousCountryCode = window.floraqueen.deliveryCountryCode;
                const hasCountryChanged = previousCountryCode !== countryCode;

                // Update country code
                window.floraqueen.deliveryCountryCode = countryCode;

                // Save to localStorage
                saveDeliveryAddressData(text, country, countryCode);

                console.log("Delivery details updated:", {
                  country: country,
                  countryCode: countryCode,
                  previousCode: previousCountryCode,
                  changed: hasCountryChanged
                });

                // If country has changed, handle market change
                if (hasCountryChanged) {
                  handleMarketChange(countryCode);
                }
              } else {
                console.warn("Could not find country code for:", country);
              }
            }

            // Generate new session token after selection
            sessionToken = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
              const r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
              return v.toString(16);
            });
          });

          suggestionsContainer.appendChild(suggestionItem);
        });
      } else {
        suggestionsContainer.style.display = "none";
      }
    } catch (error) {
      console.error("Error fetching address suggestions:", error);
      suggestionsContainer.style.display = "none";
    }
  }

  // Add input event listener with debounce
  addressInput.addEventListener("input", debounce(function(e) {
    const value = e.target.value.trim();
    fetchAddressSuggestions(value);
  }, 300)); // 300ms debounce

  // Hide suggestions when clicking outside
  document.addEventListener("click", function(e) {
    if (e.target !== addressInput && !suggestionsContainer.contains(e.target)) {
      suggestionsContainer.style.display = "none";
    }
  });

  // Try to load saved address data on DOM content loaded
  loadSavedAddressData();

  // $( "#del-date" ).datepicker({
  //     dateFormat: "dd-mm-yy",
  //     duration: "fast",
  //     numberOfMonths:2,
  //     appendTo: "body",
  //     beforeShow: function(input, inst) {
  //       setTimeout(function() {
  //         inst.dpDiv.css({
  //           top: "90vh",
  //           left: "41.5vw",
  //           right: "auto",
  //           zIndex: 9999
  //         });
  //       }, 0);
  //     }
  // });

  $(function () {
    var $input = $('#del-date');
    var $datepicker = null;

    $input.datepicker({
      numberOfMonths:2,
      dateFormat: "dd MM yy",
      minDate: 0,
      appendTo: "body",
      onSelect: function(dateText) {
        $(".main-product-cont[data-template='custom1'] .sdd-item-3 .sdd-day").text(dateText);
        $(".main-product-cont[data-template='custom1'] .sdd-item-3 .sdd-date").text('CHANGE');

        $(".main-product-cont[data-template='custom2'] .sdd-item-3 .sdd-price").text('CHANGE');
        $(".sdd-outer-item-3 .sdd-delivery-date").text(dateText);
        // console.log('hi - ', dateText)
      },
      beforeShow: function (input, inst) {
        setTimeout(function () {
          $datepicker = inst.dpDiv;
          positionDatepicker($input, $datepicker);
        }, 0);
      }
    });

    // Reposition on scroll and resize
    $(window).on('scroll resize', function () {
      if ($datepicker && $datepicker.is(':visible')) {
        positionDatepicker($input, $datepicker);
      }
    });

    function positionDatepicker($input, $picker) {
      var inputOffset = $input.offset();
      var inputHeight = $input.outerHeight();
      var inputWidth = $input.outerWidth();
      var pickerHeight = $picker.outerHeight();

      // Align to right of input, vertically centered
      $picker.css({
        position: 'absolute',
        top: inputOffset.top + (inputHeight / 2) - (pickerHeight / 2),
        left: $(".sdd-item-3").offset().left-$picker.outerWidth() - 10, // +10px padding
        // left: "auto",
        zIndex: 9999
      });
    }
  });

});
